export function getTrackingID(asset) {
  const id = asset?.tracking?.id;
  return id && id !== "unassigned" ? id : null;
}
